import React, { useState, useRef, useEffect } from 'react';
import '../styles/Timeliner.css'; // Make sure to style this CSS file accordingly
import { baseUrl } from '../config';



const TimeLiner = () => {
  const [timeFrames, setTimeFrames] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [videoDuration, setVideoDuration] = useState(0);
  const videoRef = useRef(null);

  useEffect(() => {
    // This could be used to fetch and auto-load video data if needed
  }, []);

  const handleVideoUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const videoUrl = URL.createObjectURL(file);
      videoRef.current.src = videoUrl;

      videoRef.current.onloadedmetadata = () => {
        setVideoDuration(videoRef.current.duration);
        addInitialFrame(videoRef.current.duration);
      };
    }
  };

  const addInitialFrame = (duration) => {
    const newFrame = { id: 1, start: 0, end: duration, thumbnail: generateThumbnail(0) };
    setTimeFrames([newFrame]);
  };

  const generateThumbnail = (time) => {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    videoRef.current.currentTime = time;
    context.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);
    return canvas.toDataURL();
  };

  const handleSelect = (id) => {
    setSelectedId(id);
  };

  const handleDelete = () => {
    if (selectedId === null) return;
    setTimeFrames(timeFrames.filter((frame) => frame.id !== selectedId));
    setSelectedId(null);
  };

  const handleAdd = () => {
    const newId = timeFrames.length ? timeFrames[timeFrames.length - 1].id + 1 : 1;
    const newFrame = { id: newId, start: 0, end: 10, thumbnail: generateThumbnail(0) };
    setTimeFrames([...timeFrames, newFrame]);
  };

  const handleSplit = () => {
    if (selectedId === null) return;
    const frame = timeFrames.find((frame) => frame.id === selectedId);
    if (!frame) return;

    const midPoint = (frame.start + frame.end) / 2;
    const newFrame1 = { ...frame, end: midPoint, thumbnail: generateThumbnail(frame.start) };
    const newFrame2 = { id: timeFrames.length + 1, start: midPoint, end: frame.end, thumbnail: generateThumbnail(midPoint) };

    setTimeFrames(timeFrames.map((f) => (f.id === selectedId ? newFrame1 : f)).concat(newFrame2));
    setSelectedId(null);
  };

  return (
    <div className="detailed-timeline-container">
      <input type="file" accept="video/*" onChange={handleVideoUpload} />

      <video ref={videoRef} controls className="detailed-video-display" />

      <div className="detailed-timeline">
        {timeFrames.map((frame) => (
          <div
            key={frame.id}
            className={`detailed-timeline-frame ${frame.id === selectedId ? 'detailed-selected' : ''}`}
            style={{
              left: `${(frame.start / videoDuration) * 100}%`,
              width: `${((frame.end - frame.start) / videoDuration) * 100}%`,
            }}
            onClick={() => handleSelect(frame.id)}
          >
            <img src={frame.thumbnail} alt="Frame Thumbnail" className="frame-thumbnail" />
            <div className="frame-time">
              {`Start: ${frame.start.toFixed(2)}s - End: ${frame.end.toFixed(2)}s`}
            </div>
          </div>
        ))}
      </div>

      <div className="detailed-timeline-controls">
        <button onClick={handleAdd} className="detailed-button">Add Frame</button>
        <button onClick={handleDelete} className="detailed-button">Delete Frame</button>
        <button onClick={handleSplit} className="detailed-button">Split Frame</button>
      </div>
    </div>
  );
};

export default TimeLiner;

